import { notification } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NO_PERMISSION_MESSAGE } from "../const/ConstData";
import PermissionAccess from "../utils/Permission";
import { GetToken } from "../utils";

export const usePermission = (module, type) => { 
    const [permission, setPermission] = useState(false);
    const navigate = useNavigate();
    let Permission = PermissionAccess(module) 
    useEffect(() => {
        if(GetToken()){
            if (Permission && Permission[type]) {
                setPermission(true);
            } else {
                setPermission(false);
                navigate("/no-permission", { replace: true });
                notification.destroy()
                notification["error"]({
                    message: NO_PERMISSION_MESSAGE
                })
            }
        } else {
            setPermission(true);
        }
    }, [Permission])
    return permission
};